module.exports = __webpack_public_path__ + "static/img/product3.df39b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product3.png
// module id = feqh
// module chunks = 0